function labnolIframe(t,w,h) { 
    var e = document.createElement("iframe"); 
    e.setAttribute("src", "https://www.youtube.com/embed/" + t.dataset.id + "?autoplay=1&rel=0"),
    e.setAttribute("frameborder", "0"), 
    e.setAttribute("width", w), 
    e.setAttribute("height", h), 
    e.setAttribute("allowfullscreen", "1"), 
    e.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"), 
    t.parentNode.replaceChild(e, t) 
} 
function initYouTubeVideos() { 
    for (var t = document.getElementsByClassName("youtube-player"), e = 0; e < t.length; e++) { 
        var r = t[e].dataset.id, 
        a = document.createElement("div"); a.setAttribute("data-id", r); 
        var l = document.createElement("img"); 
        if(t[e].getAttribute("data-img")){
            l.src = t[e].getAttribute("data-img")
        }else{
            l.src = "//i.ytimg.com/vi/ID/maxresdefault.jpg".replace("ID", r)
        }
        l.onload = function () {
          l.width = l.offsetWidth
          l.height = l.offsetHeight
        }
        a.appendChild(l); var c = document.createElement("div"); 
        c.setAttribute("class", "play"),
        a.appendChild(c), 
        a.onclick = function () { 
            let ytbW = this.getElementsByTagName("img")[0].offsetWidth
            let ytbH = this.getElementsByTagName("img")[0].offsetHeight
            labnolIframe(this,ytbW,ytbH) 
        }, 
        t[e].appendChild(a) 
    } 
    
} 

    document.addEventListener("DOMContentLoaded", initYouTubeVideos);